import classNames from 'classnames';

export const TableSkeleton = () => {
  return (
    <>
      {Array.from({ length: 3 }, (_, i) => (
        <div
          key={i}
          className={classNames(`
            grid-table-row-primary
            grid-table-row
            table-body-row-a
            grid-cols-[1fr_224px_224px]
            px-0
            last:border-b-0`)}
        >
          <div className="flex items-center gap-[2px]">
            <div className="skeleton-text w-[100px] h-5" />
          </div>
          <div className="flex items-center gap-[2px]">
            <div className="skeleton-text w-[50px] h-5" />
          </div>
          <div className="flex items-center gap-[2px]">
            <div className="skeleton-text w-[150px] h-5" />
          </div>
        </div>
      ))}
    </>
  );
};
